export default class Utils {
    static swiperWrapper(selector, childElements = '', classesModifier = '') {
        $(`${selector} > ${childElements}`)
            .wrapAll('<div class="swiper-wrapper"></div>')
            .addClass(`swiper-slide ${classesModifier}`)
    }
}
